var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgShieldSuspended = function SvgShieldSuspended(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 84,
    viewBox: "0 0 61 84",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0L28 0 28 24 0 24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M0 0L28 0 28 24 0 24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D00000",
    d: "M54.032 45.862c0 10.685-5.989 18.558-23.49 30.46C13.04 64.42 7.05 56.547 7.05 45.861V18.775c8.704-.925 15.67-3.887 23.49-9.934 7.82 6.047 14.788 9.009 23.491 9.933v27.088zm5.138-33.525c-10.294-.233-17.372-2.711-27.343-11.2C31.47.834 31.004.68 30.541.68c-.465 0-.928.153-1.286.457-9.968 8.489-17.046 10.967-27.341 11.2C.968 12.358.2 13.112.2 14.043v31.82C.2 61.33 10.707 71.34 29.117 83.528c.392.26.909.39 1.424.39.517 0 1.032-.13 1.424-.39 18.41-12.188 28.918-22.198 28.918-37.667V14.043c0-.931-.767-1.685-1.713-1.706z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 29)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D00000",
    d: "M14.667 6.667v6.666l5.706 3.388.96-1.613-4.666-2.775V6.667h-2zM16 0C9.373 0 4 5.373 4 12H0l5.187 5.187.093.186L10.667 12h-4c0-5.16 4.173-9.333 9.333-9.333S25.333 6.84 25.333 12c0 5.161-4.173 9.333-9.333 9.333-2.573 0-4.907-1.053-6.587-2.746L7.52 20.48C9.693 22.653 12.68 24 16 24c6.627 0 12-5.373 12-12S22.627 0 16 0z",
    mask: "url(#prefix__c)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShieldSuspended, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield_suspended.528687f8.svg";
export { ForwardRef as ReactComponent };